import { unref } from 'vue';
import { addCompareStateToQuery } from '@@/components/Compare/Common/CompareUtils';
import { replaceHistoryState } from '@@/utils/CommonUtils';
import { useLocationsStore } from '@@/stores/Locations';

export const useExplorePage = () => {
  const locationsStore = useLocationsStore();
  const metaStore = useMetaStore();
  const userFavoritesStore = useUserFavoritesStore();
  const userStore = useUserStore();

  const compare = computed(() => locationsStore.compare);
  const keepCompareOnReset = ref(false);
  const isDropdownOpen = ref(false);
  const isCompareSeasonPasses = computed(() => useLocationsStore.isCompareSeasonPasses);
  const canShowSelectFavoriteListDialog = computed(() => isCompareSeasonPasses.value);

  const favoriteLocationTypes = computed(() => {
    if (userStore.isGuest) {
      return null;
    }

    const locationTypeIds = userFavoritesStore.getLocationTypeIdsForActiveList;

    if (!locationTypeIds.length) {
      return null;
    }

    return locationTypeIds.map((id) => metaStore.locationTypesById[id]);
  });

  const pageOverflow = computed(() => isDropdownOpen.value ? 'visible' : null);
  const pageParams = computed(() => compare.value ? { compare: compare.value } : null);

  const handleDropdownClose = () => {
    isDropdownOpen.value = false;
    document.body.classList.remove('modal-open');
  };

  const handleDropdownOpen = () => {
    isDropdownOpen.value = true;
    document.body.classList.remove('modal-open');
  };

  const resetLocations = (params) => locationsStore.resetLocations(params);

  const updateUrl = (params = {}) => {
    const params2 = Object.keys(params).reduce((acc, key) => {
      acc[key] = unref(params[key]);
      return acc;
    }, {});

    const url = addCompareStateToQuery(window.location.pathname, params2);
    replaceHistoryState(url);
  };

  return {
    canShowSelectFavoriteListDialog,
    compare,
    favoriteLocationTypes,
    isCompareSeasonPasses,
    keepCompareOnReset,
    pageOverflow,
    pageParams,
    handleDropdownClose,
    handleDropdownOpen,
    resetLocations,
    updateUrl,
  };
};
